import { createElement } from 'react';

import DragSort from './DragSort';
import ClickSort from './ClickSort';

export default ({ hasDnD, ...props }) => createElement(hasDnD && !props.readOnly ? DragSort : ClickSort, props);
